import { globalObject } from '@skbkontur/global-object';
export var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return globalObject.setTimeout(resolve, ms);
  });
};